import { TEST_IDS } from '@va/constants';
import { switchActiveWebsite } from '@va/dashboard/actions/app';
import { CircleArrowIcon } from '@va/icons';
import { useTranslate } from '@va/localization';
import { getLastWebsiteId } from '@va/standalone/shared/helpers';
import { Button } from '@va/ui/design-system';
import { Link } from '@va/util/router';
import { useDispatch } from 'react-redux';
import { useHistory } from 'react-router';

export const GoToLastWebsiteButton = () => {
  const dispatch = useDispatch();
  const translate = useTranslate();
  const history = useHistory();

  return (
    <Link
      to={'/'}
      onClick={() => {
        const lastWebsite = getLastWebsiteId();
        if (lastWebsite) {
          dispatch(switchActiveWebsite({ websiteId: lastWebsite }));
        } else {
          history.push('/');
        }
      }}
    >
      <Button
        color='tertiary'
        icon={(iconClassName) => <CircleArrowIcon className={iconClassName} color={'#696969'} />}
        text={translate('topBar.goBackBtn')}
        className='shrink-0'
        data-testid={TEST_IDS.generic.buttons.goToPrevWebsite}
      />
    </Link>
  );
};
